import {Component, Input} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-text-collapse',
  animations: [
    trigger('slideToggle', [
      state('void', style({ height: '0px', overflow: 'hidden', opacity: 0 })),
      state('*', style({ height: '*', overflow: 'hidden', opacity: 1 })),
      transition(':enter', [animate('300ms ease-out')]),
      transition(':leave', [animate('300ms ease-in')]),
    ])
  ],
  templateUrl: './text-collapse.component.html',
  styleUrl: './text-collapse.component.scss'
})
export class TextCollapseComponent {
  @Input() text: string = '';
  isTextVisible: boolean = false;

  toggleText(): void {
    this.isTextVisible = !this.isTextVisible;
  }
}
